import { css, styled } from 'styled-components';

export const BODY_XS_XS_STYLES = css`
    font-family: var(--type-font-family, Poppins), sans-serif;
    font-size: var(--fontsize-body-xs, 12px);
    font-weight: 400;
    line-height: var(--line-height-body-xs, 16px);
`;

export const BODY_SM_SM_STYLES = css`
    font-family: var(--type-font-family, Poppins), sans-serif;
    font-size: var(--fontsize-body-sm, 14px);
    font-weight: 400;
    line-height: var(--line-height-body-sm, 20px);
`;

export const BODY_SM_SM_MEDIUM_STYLES = css`
    font-family: var(--type-font-family, Poppins), sans-serif;
    font-size: var(--fontsize-body-sm, 14px);
    font-weight: 500;
    line-height: var(--line-height-body-sm, 20px);
`;

export const BODY_LG_LG_MEDIUM_STYLES = css`
    font-family: var(--type-font-family, Poppins), sans-serif;
    font-size: var(--fontsize-body-lg, 18px);
    font-weight: 500;
    line-height: var(--line-height-body-lg, 24px);
`;

export const BODY_LG_LG_BOLD_STYLES = css`
    font-family: var(--type-font-family, Poppins), sans-serif;
    font-size: var(--fontsize-body-lg, 18px);
    font-weight: 700;
    line-height: var(--line-height-body-lg, 24px);
`;

export const HEADING_HEADING_S_STYLES = css`
    font-family: var(--type-font-family, Poppins), sans-serif;
    font-size: var(--fontsize-heading-xxs, 16px);
    font-weight: var(--type-font-weight-bold, 600);
    line-height: normal;
`;

export const HEADING_XS_STYLES = css`
    font-family: var(--type-font-family, Poppins), sans-serif;
    font-size: var(--fontsize-heading-xs, 18px);
    font-weight: 600;
    line-height: var(--line-height-heading-xs, 26px);
`;

export const BODY_XS_XS_MEDIUM_STYLES = css`
    font-family: var(--type-font-family, Poppins), sans-serif;
    font-size: var(--fontsize-body-xs, 12px);
    font-weight: 500;
    line-height: var(--line-height-body-xs, 16px);
`;

export const BODY_MD_MD_STYLES = css`
    font-family: var(--type-font-family, Poppins), sans-serif;
    font-size: var(--fontsize-body-md, 16px);
    font-weight: 400;
    line-height: var(--line-height-body-md, 24px);
`;

export const BODY_MD_MD_MEDIUM_STYLES = css`
    font-family: var(--type-font-family, Poppins), sans-serif;
    font-size: var(--fontsize-body-md, 16px);
    font-weight: 500;
    line-height: var(--line-height-body-md, 24px);
`;

export const HEADING_SM_STYLES = css`
    font-family: var(--type-font-family, Poppins), sans-serif;
    font-size: var(--fontsize-heading-sm, 24px);
    font-weight: 600;
    line-height: var(--line-height-heading-sm, 32px);
`;

export const HEADING_XXS_STYLES = css`
    font-family: var(--type-font-family, Poppins), sans-serif;
    font-size: var(--fontsize-heading-xxs, 16px);
    font-weight: 600;
    line-height: var(--line-height-heading-xxs, 22px);
`;

export const HEADING_XXXS_STYLES = css`
    font-family: var(--type-font-family, Poppins), sans-serif;
    font-size: var(--fontsize-heading-xxxs, 14px);
    font-weight: 600;
    line-height: var(--paragraph-spacing-body-lg, 20px);
`;

export const BODY_SM_SM_BOLD_STYLES = css`
    font-family: var(--type-font-family, Poppins), sans-serif;
    font-size: var(--fontsize-body-sm, 14px);
    font-weight: 700;
    line-height: var(--line-height-body-sm, 20px);
`;

export const BODY_MD_BOLD_STYLES = css`
    font-family: var(--type-font-family, Poppins), sans-serif;
    font-size: var(--fontsize-body-sm, 16px);
    font-weight: 700;
    line-height: var(--line-height-body-sm, 24px);
`;

export const BODY_MD_MD_BOLD_STYLES = css`
    font-family: var(--type-font-family, Poppins), sans-serif;
    font-size: var(--fontsize-body-md, 16px);
    font-weight: 700;
    line-height: var(--line-height-body-md, 24px);
`;

export const BODY_REGULAR_STYLES = css`
    font-family: Roboto, serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
`;

export const HEADING_MD_STYLES = css`
    font-family: var(--type-font-family, Poppins), sans-serif;
    font-size: var(--fontsize-heading-md, 28px);
    font-weight: 600;
    line-height: var(--line-height-heading-md, 36px);
`;

export const HEADING_LG_STYLES = css`
    font-family: var(--type-font-family, Poppins), sans-serif;
    font-size: var(--fontsize-heading-lg, 32px);
    font-weight: 600;
    line-height: var(--line-height-heading-lg, 40px);
`;

export const BODY_SM_SM_LINK_STYLES = css`
    font-family: var(--type-font-family, Poppins), sans-serif;
    font-size: var(--fontsize-body-sm, 14px);
    font-weight: 400;
    line-height: var(--line-height-body-sm, 20px);
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: auto;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
`;

export const BODY_XS_XS_SMALL_STYLES = css`
    font-family: var(--type-font-family, Poppins), sans-serif;
    font-size: 10px;
    font-weight: 500;
    line-height: var(--line-height-body-xs, 16px);
`;

export const HEADING_XXL_STYLES = css`
    font-family: var(--type-font-family, Poppins), sans-serif;
    font-size: var(--fontsize-heading-hero, 48px);
    font-weight: 600;
    line-height: var(--line-height-heading-hero, 56px);
`;

export const STYLED_COMPONENTS_TEXT = {
    'body/xs/xs': styled.div`
        ${BODY_XS_XS_STYLES};
    `,
    'body/sm/sm': styled.div`
        ${BODY_SM_SM_STYLES};
    `,
    'body/sm/sm-medium': styled.div`
        ${BODY_SM_SM_MEDIUM_STYLES};
    `,
    'body/lg/lg-medium': styled.div`
        ${BODY_LG_LG_MEDIUM_STYLES};
    `,
    'body/lg/lg-bold': styled.div`
        ${BODY_LG_LG_BOLD_STYLES};
    `,
    'body/md/md-bold': styled.div`
        ${BODY_MD_BOLD_STYLES};
    `,
    'Heading/Heading-S': styled.div`
        ${HEADING_HEADING_S_STYLES};
    `,
    'heading/xs': styled.div`
        ${HEADING_XS_STYLES};
    `,
    'body/xs/xs-medium': styled.div`
        ${BODY_XS_XS_MEDIUM_STYLES};
    `,
    'heading/sm': styled.div`
        ${HEADING_SM_STYLES};
    `,
    'body/md/md': styled.div`
        ${BODY_MD_MD_STYLES};
    `,
    'body/md/md-medium': styled.div`
        ${BODY_MD_MD_STYLES};
    `,
    'heading/xxs': styled.div`
        ${HEADING_XXS_STYLES};
    `,
    'heading/xxxs': styled.div`
        ${HEADING_XXXS_STYLES};
    `,
    'body/sm/sm-bold': styled.div`
        ${BODY_SM_SM_BOLD_STYLES};
    `,
    'body/regular': styled.div`
        ${BODY_REGULAR_STYLES};
    `,
    'heading/md': styled.div`
        ${HEADING_MD_STYLES};
    `,
    'body/sm/sm-link': styled.a`
        ${BODY_SM_SM_LINK_STYLES};
    `,
    'body/xs/xs-small': styled.div`
        ${BODY_XS_XS_SMALL_STYLES};
    `,
};

export const BodySmSmMedium = styled(STYLED_COMPONENTS_TEXT['body/sm/sm-medium'])`
    flex: 1 0 0;
    color: var(--colors-text-body, #50566e);
`;

export const BodySmSm = styled(STYLED_COMPONENTS_TEXT['body/sm/sm'])`
    flex: 1 0 0;
    color: var(--colors-text-body, #50566e);
`;

export const HeadingXxs = styled(STYLED_COMPONENTS_TEXT['heading/xxs'])`
    color: var(--colors-text-filled, #2f3449);
    align-self: stretch;
`;

export const HeadingXxxs = styled(STYLED_COMPONENTS_TEXT['heading/xxxs'])`
    color: var(--colors-text-headings, #3e445c);
    align-self: stretch;
`;

export const BodyXsXsMedium = styled(STYLED_COMPONENTS_TEXT['body/xs/xs-medium'])`
    color: var(--colors-text-action, #2171c6);
`;

export const BodyXsXs = styled(STYLED_COMPONENTS_TEXT['body/xs/xs'])`
    color: var(--colors-text-action, #2171c6);
`;

export const HeadingSm = styled(STYLED_COMPONENTS_TEXT['heading/sm'])`
    color: var(--colors-text-headings, #3e445c);
    text-align: center;
`;

export const BodyMdMd = styled(STYLED_COMPONENTS_TEXT['body/md/md'])`
    color: var(--colors-text-body, #50566e);
    text-align: center;
`;

export const BodyMdMdMedium = styled(STYLED_COMPONENTS_TEXT['body/md/md-medium'])`
    color: var(--colors-text-body, #50566e);
`;

export const BodySmSmBold = styled(STYLED_COMPONENTS_TEXT['body/sm/sm-bold'])`
    color: var(--colors-text-on-action, #fff);
`;

export const BodyRegular = styled(STYLED_COMPONENTS_TEXT['body/regular'])`
    color: var(--colors-text-body, #50566e);
`;

export const HeadingMd = styled(STYLED_COMPONENTS_TEXT['heading/md'])`
    color: var(--colors-text-headings, #3e445c);
`;

export const BodySmSmLink = styled(STYLED_COMPONENTS_TEXT['body/sm/sm-link'])`
    color: var(--colors-text-action, #2171c6);
    cursor: pointer;
    user-select: none;
`;

export const BodyXsXsSmall = styled(STYLED_COMPONENTS_TEXT['body/xs/xs-small'])`
    color: var(--colors-text-body, #50566e);
`;

export const BodyLgLgBold = styled(STYLED_COMPONENTS_TEXT['body/lg/lg-bold'])`
    color: var(--colors-text-body, #50566e);
    text-align: center;
`;
